import React from 'react';
import styled from 'styled-components';
import { HideDuring } from 'react-hide-on-scroll';

const Box = styled.div`
  .hide {
    display: none;
  }
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 2;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
`;

const ChatBox = () => {
  const showWidget = () => {
    try {
      window.Tawk_API.toggle();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <HideDuring inverse={true}>
      <Box onClick={showWidget}>
        <img src="Images/chat.png" alt="chat_icon" />
      </Box>
    </HideDuring>
  );
};

export default ChatBox;
